import './style.scss'
import React, { useState } from 'react'

export interface AccordionProps {
    title: string
    badge?: React.ReactNode
    subtitle?: string
    defaultOpen?: boolean
    open?: boolean
    onToggle?: (open: boolean) => void
    children: React.ReactNode
    className?: string
}

export const Accordion: React.FC<AccordionProps> = ({
                                                        title, badge, subtitle, defaultOpen = false, open, onToggle, children, className = '',
                                                    }) => {
    const isControlled = open !== undefined
    const [internalOpen, setInternalOpen] = useState(defaultOpen)
    const isOpen = isControlled ? open : internalOpen

    const toggle = () => {
        const next = !isOpen
        if (!isControlled) setInternalOpen(next)
        onToggle?.(next)
    }

    return (
        <div className={`accordion ${isOpen ? 'accordion--open' : ''} ${className}`}>
            <button type="button" className="accordion__header" onClick={toggle}>
                <span className="accordion__title-group">
                    <span className="accordion__title">{title}</span>
                    {badge}
                </span>
                <svg
                    className="accordion__chevron"
                    width="20" height="20" viewBox="0 0 20 20" fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                >
                    <path d="M5 7.5L10 12.5L15 7.5" stroke="#667085" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
                </svg>
            </button>

            {subtitle && isOpen && <div className="accordion__subtitle">{subtitle}</div>}

            <div className="accordion__body">
                {isOpen && <div className="accordion__content">{children}</div>}
            </div>
        </div>
    )
}

export default Accordion